import { useState } from 'react';
import { mdiLinkedin, mdiTwitter } from '@mdi/js';
import { toast } from 'react-toastify';
import Icon from '@mdi/react';
import { HashLink as Link } from 'react-router-hash-link';
import FooterLogo from '../assets/footer-company-logo.svg';
import ContactUsLink from './ContactUsLink';
import useWake from '../helpers/useWakeServer';

function Footer() {
  const { isWaking, wakeServer, shouldWakeServer } = useWake();
  const [email, setEmail] = useState('');
  const [isFormValid, setIsFormValid] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Validate the form whenever email input changes
  function handleEmailChange(event) {
    const inputEmail = event.target.value;
    setEmail(inputEmail);

    // Simple email validation
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputEmail);
    setIsFormValid(isValidEmail);
  }

  // Handle form submission
  async function handleSubmit(event) {
    event.preventDefault(); // Prevent form default action
    setIsSubmitting(true);

    const formData = { email };

    try {
      if (shouldWakeServer()) {
        await wakeServer();
      }

      const response = await fetch('https://gartekweb.onrender.com/wait-list', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        if (response.status === 409) {
          toast.info('You are already a user', {
            toastId: 4,
          });
          return;
        }
        throw new Error('Failed to submit form.');
      }

      // Optionally, show success feedback
      toast.success('Successfully joined the waitlist!', {
        toastId: 5,
      });
    } catch (error) {
      toast.error(`Error: ${error.message}`, {
        toastId: 6,
      });
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <footer className="bg-gold bg-footer-rings bg-no-repeat bg-right md:bg-footer-rings-medium md:bg-p-footer-rings-medium text-white">
      <div className="flex items-center justify-center w-full flex-col">
        <section className="flex flex-col items-center max-w-lg lg:max-w-3xl gap-5 px-8 py-6">
          <h1 className="max-w-md md:max-w-lg text-center mb-5 text-xl lg:text-4xl font-extrabold">
            Be the first to know what happens at gartekcloude! Subscribe Now
          </h1>

          <form
            onSubmit={handleSubmit}
            className="flex md:w-3/4 sm:p-2 lg:py-3 lg:px-2.5 py-2.5 px-2 bg-white-variant rounded-lg gap-1"
          >
            <div className="flex flex-1 ">
              <input
                type="email"
                name="email"
                id="email"
                value={email}
                onChange={handleEmailChange}
                required
                placeholder="Your Email"
                className="text-xs w-full lg:text-xl bg-white-variant text-black-variant ease-in-out focus:outline-none focus:border-0 focus:border-b focus:border-opaque-gold"
              />
            </div>
            <div className="flex footer-form-submit-btn-container">
              <button
                className={`bg-gold text-xs lg:text-xl rounded-[4px] md:rounded-lg font-semibold sm:py-2.5 sm:px-3 py-1.5 px-1 md:px-3.5 md:py-2.5 ${
                  isFormValid
                    ? 'border-gold'
                    : 'opacity-35 border-gray-400 cursor-not-allowed'
                }`}
                type="submit"
                disabled={!isFormValid || isSubmitting || isSubmitting}
              >
                {isSubmitting || isWaking ? 'Sending...' : 'Send'}
              </button>
            </div>
          </form>

          <nav className="my-8 md:my-4">
            <ul className="flex-col items-center md:flex-row flex gap-8 md:gap-5">
              <li className="nav-item">
                <Link to="/#about" smooth>
                  <span className="font-bold text-white text-2xl">About</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/#faqs" smooth>
                  <span className="font-bold text-white text-2xl">FAQs</span>
                </Link>
              </li>
              <li className="nav-item">
                <ContactUsLink
                  childEl={
                    <span className="font-bold text-white text-2xl">
                      Contact Us
                    </span>
                  }
                />
              </li>
            </ul>
          </nav>

          <div className="gap-3 mb-8 md:my-4 items-center flex">
            <a
              className="flex bg-white-opaque-2 p-2 rounded-full"
              href="https://x.com/gartekcloude?t=7x-qcXQUdoMhWaFsdTEqQQ&s=09"
            >
              <Icon path={mdiTwitter} size={0.8} />
            </a>
            <a
              className="flex bg-white-opaque-2 p-2 rounded-full"
              href="https://www.linkedin.com/company/gartekcloudehq/"
            >
              <Icon path={mdiLinkedin} size={0.8} />
            </a>
          </div>

          <div className="copy-right-section-container d-flex__col">
            <div className="img-container">
              <img src={FooterLogo} alt="" className="img" />
            </div>
          </div>
          <p className="text-xs">&copy; 2024 GartekCloude</p>
        </section>
      </div>
    </footer>
  );
}

export default Footer;
